module.exports = __webpack_public_path__ + "static/img/yjzc.9466c029.png";